import { useState } from 'react'

/**
 * Custom hook to manage dialog open/close state
 * @param {boolean} initialState - Initial state of the dialog
 * @returns {Object} Object containing state, open and close functions
 */
export const useDialogState = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  return {
    isOpen,
    open,
    close,
  }
}

/**
 * Custom hook to manage multiple dialog states
 * @param {string[]} dialogNames - Array of dialog names
 * @returns {Object} Object containing state and handlers for each dialog
 */
export const useMultipleDialogs = (dialogNames) => {
  const initialState = dialogNames.reduce((acc, name) => {
    acc[name] = false
    return acc
  }, {})

  const [dialogStates, setDialogStates] = useState(initialState)

  const dialogs = {}
  dialogNames.forEach((name) => {
    dialogs[name] = {
      isOpen: dialogStates[name],
      open: () => setDialogStates(prev => ({ ...prev, [name]: true })),
      close: () => setDialogStates(prev => ({ ...prev, [name]: false }))
    }
  })

  return dialogs
}